import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, fonts } from "@similarweb/styles";
import { IconButton, Button } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const PageTitleStyle = styled.div<{ widthToReduce: number }>`
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        > * {
            margin-right: 10px;
        }
    }

    @media screen and (max-width: 1400px) {
        width: calc(100% - ${({ widthToReduce }) => widthToReduce}px);
    }
`;

export const TitleStyle = styled.div`
    font-family: ${fonts.$dmSansFontFamily};
    font-size: 24px;
    font-weight: 500;
    line-height: 1.17;
    color: ${colorsPalettes.carbon[500]};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 50px;
`;

export const TooltipStyle = styled.div`
    margin: 0 5px;
`;

export const EducationIconStyle = styled.div`
    margin-right: 3px;
    cursor: pointer;
`;

export const IconButtonStyled = styled(IconButton)`
    ${SWReactIcons} {
        svg {
            path {
                fill: #4f8df9;
            }
        }
    }
`;

const EducationIconStyleProminent = styled(Button)`
    min-width: unset;
`;

const EducationHatIcon = styled.img`
    width: 22px;
`;

export const TitleContainer = styled(FlexRow)`
    justify-content: start;
    align-items: center;
`;
